import React, { useRef } from "react";
import cn from "classnames";
import { css } from "@emotion/react";
import { useGlobalKeyListener } from "../../../hooks/use-global-key-listener";
import { ModalRootPortalEntrance } from "../technical/ModalRootPortalEntrance";
import { CSS_MQ } from "../../../styles/breakpoints";
import { CloseButton } from "./CloseButton";

export const SwarovskiModalWrapper: React.FC<
  React.PropsWithChildren<{
    modalIsOpen: boolean;
    hideModalCallback: () => void;
  }>
> = props => {
  const { modalIsOpen, hideModalCallback } = props;

  // useClickOutside(divRef, hideModalCallback, true);
  const divRef = useRef<HTMLDivElement | null>(null);

  useGlobalKeyListener("Escape", hideModalCallback, [hideModalCallback], modalIsOpen);

  const wrapperStyles = css`
    width: 100%;
    padding: 30px 30px;
    ${CSS_MQ.atLeastSm} {
      width: 500px;
      padding: 36px 48px;
    }

    // arbitrary margin
    --margin: calc(var(--header-unfixed-height) + 60px);
    ${CSS_MQ.atLeastLg} {
      // arbitrary margin
      --margin: calc(var(--header-unfixed-height));
    }
    ${CSS_MQ.atLeastXl} {
      // arbitrary margin
      --margin: calc(var(--header-unfixed-height) + 40px);
    }

    ${CSS_MQ.lowResNotebook} {
      --margin: calc(var(--header-unfixed-height) + 10px);
    }

    @media (max-height: 800px) {
      --margin: calc(var(--header-unfixed-height) + 10px);
    }

    // Duplicated to serve as a fallback
    max-height: calc(100vh - var(--margin) - 10px);
    max-height: calc(100dvh - var(--margin) - 10ox);

    overflow-y: auto;

    margin-top: var(--margin);
    margin-left: auto;
    margin-right: auto;

    display: flex;
    flex-direction: column;
    background-color: var(--so-green-white);

    position: relative;
  `;

  return (
    <ModalRootPortalEntrance>
      <div
        className={cn(modalIsOpen ? "visible" : "hidden")}
        css={css`
          &.hidden {
            display: none;
          }

          &.visible {
          }

          height: 100%;
          width: 100%;
          position: fixed;

          z-index: 110;
          background-color: rgba(0, 0, 0, 0.75);
        `}
      >
        <div ref={divRef} css={wrapperStyles} className="js-modal-wrapper">
          <CloseButton onClick={hideModalCallback} withEnhandedBackground={false} />

          {props.children}
        </div>
      </div>
    </ModalRootPortalEntrance>
  );
};
